import { getExpiredCouponsCount } from 'shared/helpers/api/helpers';
import { IDetailState } from 'shared/store/details/types';

type BestPriceOffers = Omit<Partial<IDetailState['productOffers']>, 'bestOffers'> & {
  bestOffers?: (IDetailState['productOffers']['bestOffers'][number] & {
    offerDiscount?: number;
  })[];
};

export const getBestPriceTrackingData = (
  offers: BestPriceOffers,
  sellingPrice: string | number,
  canShowBestPrice = true
) => {
  const hasExpiredOffers = getExpiredCouponsCount(offers.bestOffers || []) > 0;
  const isBestPriceShown =
    canShowBestPrice &&
    !offers.fetching &&
    !hasExpiredOffers &&
    Boolean(offers.offerBestPrice || offers.bestOfferMessage || offers.bestOffers?.length);
  const totalBestOfferDiscount =
    (offers.bestOffers || []).reduce((sum, offer) => sum + (offer?.offerDiscount || 0), 0) ||
    offers.bestOfferTotalDiscount ||
    0;
  const bestPrice =
    totalBestOfferDiscount > 0
      ? Number(sellingPrice) - totalBestOfferDiscount
      : offers.offerBestPrice;

  return {
    is_best_price_shown: isBestPriceShown,
    is_best_price_eligible: !offers.fetching && !hasExpiredOffers && Boolean(offers.offerBestPrice),
    best_price:
      !offers.fetching && !hasExpiredOffers && Number(bestPrice) > 0
        ? Number(bestPrice)
        : undefined,
  };
};
